import { Alert, Button, Form, Select } from 'antd'
import { useState, useEffect } from 'react'
import { getStatus, getTrainingIds } from './helpers'
import './index.scss'
{ Option } = Select

StatusML = ({ service: { name } }) ->
  [showFeedback, setShowFeedback] = useState(false)
  [feedback, setFeedback] = useState({status: '', totalTrainingTime: ''})
  [hasErr, setHasErr] = useState(false)
  [idList, setIdList] = useState([])
  [loading, setLoading] = useState(false)

  useEffect( ->
    init()
    undefined
  , [])

  init = ->
    setLoading(true)
    try
      ids = JSON.parse(await getTrainingIds('false', name))
      setIdList(ids)
    catch e
      setFeedback({ message: e.message })
      setHasErr(true)
    setLoading(false)

  onFinish = ({ trainingId }) ->
    setHasErr(false)
    try
      parsed = JSON.parse(await getStatus({ trainingId, name }))
      if parsed.status is 'error' then setHasErr(true)
      setFeedback(parsed)
    catch e
      setFeedback({ message: e.message })
      setHasErr(true)
    setShowFeedback(true)

  statusReport = (
    <p style={{ marginTop: '14px' }}>
      Status: { feedback.status }
      <br/>
      Training Time: { feedback.totalTrainingTime }
      <br/>
      { if feedback['training score']? then "Training Accuracy: #{feedback['training score']}" }
      <br/>
      { if feedback.status is 'error' then "Error Message: #{feedback.message}" }
    </p>
  )

  <div className="ml-form-container">
    <Form
      className="ml-action-form"
      onFinish={onFinish}
    >
      <Form.Item
        name="trainingId"
        rules={[{ required: true, message: 'Training ID required' }]}
      >
        <Select
          showSearch
          placeholder={if loading then "Please Wait" else "Select a Training ID"}
          optionFilterProp="children"
          filterOption={(input, option) ->
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          {
            if not loading then idList.map((id) ->
              <Option value={id} key="ml-status-#{id}">
                { id }
              </Option>
            )
          }
        </Select>
      </Form.Item>
      <Form.Item name="getStatus">
        <Button htmlType="submit">
          Get Status
        </Button>
      </Form.Item>
    </Form>
    { if showFeedback
      <Alert
        style={{marginBottom: '24px', textAlign: 'center'}}
        message={if hasErr then "Error Occured" else "Success"}
        description={statusReport}
        type={ if hasErr then "error" else "success" }
        closable
        onClose={ ->
          if hasErr then setHasErr(false)
          setShowFeedback(false)
          setFeedback([])
        }
      />
    }
  </div>

export default StatusML
